import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import { PLButton } from './styled';

interface IProps {
    isLoading: boolean,
    onPayHandler: () => void,
}

const LoyaltyButton = ({ isLoading, onPayHandler }: IProps): JSX.Element => {

    return (
        <PLButton
            size={btnSizes.LARGE}
            type={btnTypes.PRIMARY}
            text={'Оплатить бонусами'}
            onClick={onPayHandler}
            isLoading={isLoading}
        />
    );
};

export default LoyaltyButton;
